import React, {useState} from 'react';
import {CheckIcon, CopyIcon, type LucideIcon} from 'lucide-react';
import Icon from './Icon.tsx';

interface CopyButtonProps {
    id?: string;
    cssClass: string;
    copyText: string;
    title?: string;
    icon?: LucideIcon;
    /** Shown beside the icon until the text is copied. */
    label?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
    id,
    cssClass,
    copyText,
    title,
    icon = CopyIcon,
    label = ''
}) => {
    const [state, setState] = useState({
        text: label,
        icon,
        isDisabled: false
    });

    const copyToClipboardAsync = async () => {
        const temp = state;
        setState({
            text: 'Copied',
            icon: CheckIcon,
            isDisabled: true
        });
        await navigator.clipboard.writeText(copyText);
        setTimeout(() => {
            setState(temp);
        }, 2000);
    };

    return (
        <a
            className={cssClass}
            type="button"
            id={id}
            onClick={copyToClipboardAsync}
            style={{whiteSpace: 'nowrap'}}
        >
            {state.text}
            <Icon icon={state.icon} aria-hidden="true" title={title} />
            <span className="visually-hidden">Copy</span>
        </a>
    );
};

export default CopyButton;
